'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMsAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 2C0 0.895431 0 0 0 0H28C28 0 28 0.895431 28 2V20C28 20 27.1046 20 26 20H2C0.895432 20 0 20 0 20V2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V20H0V0Z", fill: "#07319C" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.3335 9.99998C17.3335 8.90624 17.3335 7.61312 17.3335 6.6658C17.3335 5.92942 17.9305 5.33331 18.6668 5.33331H22.6668C23.4032 5.33331 24.0002 5.92942 24.0002 6.6658C24.0002 7.61313 24.0002 8.90624 24.0002 9.99998C24.0002 13.3333 20.6668 14.6666 20.6668 14.6666C20.6668 14.6666 17.3335 13.3333 17.3335 9.99998Z",
          fill: "#A63D09"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3335 6.6658V9.99998C17.3335 10.7709 17.5118 11.4348 17.7859 12H23.5478C23.8219 11.4348 24.0002 10.7709 24.0002 9.99998V6.6658C24.0002 5.92942 23.4032 5.33331 22.6668 5.33331H18.6668C17.9305 5.33331 17.3335 5.92942 17.3335 6.6658Z",
          fill: "#08B9D6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M21.3338 6.66663H20.0005V7.99996H18.667V9.33329H20.0005V12H21.3338V9.33329H22.667V7.99996H21.3338V6.66663Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      )
    ]
  }
);
const VpFlagMsAsset = forwardRef(FlagMsAsset);

export { VpFlagMsAsset as default };
